<template>
    <df-app title="Digital.Check">
        <df-exam :steps="steps" :input="demoData" @started="onStarted" @complete="onComplete">
            <div v-if="completed">
                <be-progress v-if="!submitted">Antworten werden übermittelt …</be-progress>

                <step-summary :assessment="data" v-if="submitted"/>
            </div>
        </df-exam>

        <df-confirm :route.sync="routeLeave">
            <h3>Digital.Check nicht gespeichert</h3>
            <p>Wollen Sie diese Seite wirklich verlassen? Alle Eingaben gehen dabei verloren!</p>
        </df-confirm>
    </df-app>
</template>

<script>
    import { mapGetters } from 'vuex';

    import check from '../../mixins/check';
    import env from '../../mixins/env';
    import errorHandler from '../../mixins/errorHandler';

    import DfExam from '../blocks/DfExam';
    import StepSummary from './check/07-Summary';

    export default {
        mixins: [check, env, errorHandler],
        components: { DfExam, StepSummary },

        data: () => ({
            started: false,
            completed: false,
            submitted: false,
            routeLeave: null,

            data: null,
            demoData: null,
        }),

        computed: {
            ...mapGetters('user', ['isCoach']),

            steps() {
                const steps = [];

                steps.push({ label: 'Organisation', component: () => import('./check/01-Organisation') });
                steps.push({ label: 'Auftraggeber', component: () => import('./check/02-Contact') });
                steps.push({ label: 'Eigenschaften', component: () => import('./check/03-Properties') });
                steps.push({ label: 'Systeme', component: () => import('./check/04-Software') });
                steps.push({ label: 'Prozesse', component: () => import('./check/05-Processes') });

                if (!this.isCoach) {
                    steps.push({ label: 'Coach', component: () => import('./check/06-Coach') });
                }

                steps.push({ label: 'Digital.Assessment' });

                return steps;
            },
        },

        methods: {
            initialize() {
                this.completed = false;
                this.submitted = false;
                this.data = null;

                if (this.isDebugMode) {
                    this.demoData = {
                        company: 'Musterfirma',
                        address: 'Musterstrassse 1',
                        postal: '9999',
                        city: 'Musterhausen',
                        country: 'CH',
                        website: 'https://example.com',
                        gender: 'm',
                        firstname: 'Max',
                        lastname: 'Muster',
                        position: '',
                        email: 'max.muster@example.com',
                        phone: '+41 00 000 00 00',
                        sector: '/sectors/ab45b406-6938-4c74-83cb-0222eef872cd',
                        employees: '1234',
                    };
                }
            },

            onStarted() {
                this.started = true;
            },

            async onComplete(formData) {
                this.completed = true;

                try {
                    this.data = await this.saveCheckData(formData).save();
                    this.submitted = true;
                } catch (response) {
                    this.catchResponseWithDialog(
                        'Fehler beim Übermitteln des Digital.Check',
                        this.data,
                        response,
                    );
                }
            },
        },

        watch: {
            $route(to) {
                this.initialize();

                if (to.name === 'check') {
                    this.$router.replace({ name: 'check_new' });
                }
            },
        },

        mounted() {
            this.initialize();

            if (this.$route.name === 'check') {
                this.$router.replace({ name: 'check_new' });
            }
        },

        beforeRouteLeave(to, from, next) {
            if (from.name === 'check' || !this.started || this.completed) {
                next();
                return;
            }

            this.routeLeave = next;
        },
    };
</script>
